import { ElementRef } from '@angular/core';

import { BehaviorSubject, Subject, delay } from 'rxjs';

import { CamCalendarEngine } from '../../engine/calendar-engine';
import { CamEventRecord } from '../../engine/models/event-record';
import { CamStoreBeforeAddEvent } from '../../engine/models/store';
import { CalendarModeType, CamAddEventRequest } from '../../types/calendar';

export class CamCalendarData {
  private _refreshedDate$ = new Subject();

  public component: ElementRef | null = null;

  public addEventRequest$ = new Subject<CamAddEventRequest>();
  public refreshedDate$ = this._refreshedDate$.pipe(delay(50));
  public api: CamCalendarEngine | null = null;
  public ready$ = new BehaviorSubject(false);

  public getDates() {
    const activeView = this.api?.getActiveView();
    if (!activeView) {
      return null;
    }
    return {
      start: activeView.startDate,
      end: activeView.endDate,
    };
  }

  public isReady() {
    return this.ready$.value;
  }

  public setApi(api: CamCalendarEngine, component: ElementRef) {
    this.api = api;
    this.component = component;

    this.api.on('dateRangeChange', () => {
      this._refreshedDate$.next(null);
    });

    this.api.on('modeChange', () => {
      this._refreshedDate$.next(null);
    });

    this.api.eventStore.onBeforeAdd = (event: CamStoreBeforeAddEvent<CamEventRecord>) => {
      const record = event.records[0];
      if (!record) {
        return;
      }
      const brutJson = record.getData('brutJson');
      const addEventRequest: CamAddEventRequest = {
        startDate: record.getData('startDate'),
        endDate: record.getData('endDate'),
        ...(brutJson ? JSON.parse(brutJson) : {}),
      };

      this.addEventRequest$.next(addEventRequest);
    };

    queueMicrotask(() => this.ready$.next(true));
  }

  public setMode(mode: CalendarModeType) {
    if (!this.api) {
      return;
    }
    this.api.setMode(mode);
  }
  public destroy() {
    this.api?.destroy();
    this.api = null;
    this.component = null;
  }
}
